import { InputField } from "./InputField";
import { Lock, Mail, ArrowLeft } from 'lucide-react'; 
// Component for the Password Reset View
export const ForgotPasswordView = ({ email, password, handleEmailChange, handlePasswordChange, handlePasswordReset, resetMessage, setCurrentView, clearErrors, resetTrigger }) => 
  {
    return (
    
    // We keep the transition wrapper for the fade effect
    <div key="forgot-password-view" className="transition duration-500 ease-in-out transform animate-fade-in">
      <div className="flex items-center mb-4">
        <button 
          onClick={() => { setCurrentView('signIn'); clearErrors(); }}
          className="text-slate-400 hover:text-slate-100 transition duration-300 mr-2"
        >
          <ArrowLeft className="h-5 w-5" />
        </button>
        <h2 className="text-2xl font-semibold text-slate-50">Reset Password</h2>
      </div>
      <p className="text-slate-400 mb-8 text-sm">
        Enter the email address associated with your account, and we'll email you a password reset link.
      </p>

      {/* Conditional Reset Message Block */}
      {resetMessage && (
        <div 
          className={`mb-6 p-3 rounded-lg border text-sm animate-fade-in ${
            resetMessage.type === 'success' 
              ? 'bg-green-900/50 border-green-700 text-green-300'
              : 'bg-red-900/50 border-red-700 text-red-300'
          }`}
        >
          <p className="font-medium text-center tracking-wide">{resetMessage.text}</p>
        </div>
      )}

      <form onSubmit={handlePasswordReset} className="space-y-6" method="GET">
        
        {/* Email Field - Uses handleEmailChange */}
        {!resetTrigger.reset && <div className="group">
          <label htmlFor="email" className="block text-sm font-medium text-slate-100 tracking-wide mb-1">
            EMAIL ADDRESS
          </label>
          <InputField
            id="email"
            name="email"
            type="email"
            autoComplete="email"
            placeholder="identity@knoesis.co.uk"
            Icon={Mail}
            value={email}
            onChange={handleEmailChange}
            hasError={false}
          />
        </div>}

         {/* Password Field - Uses handlePasswordChange */}
        {resetTrigger && resetTrigger.reset && <div className="group">
          <label htmlFor="email" className="block text-sm font-medium text-slate-100 tracking-wide mb-1">
            NEW PASSWORD
          </label>
          <InputField
            id="password"
            name="password"
            type="password"
            autoComplete="password"
            placeholder="identity@knoesis.co.uk"
            Icon={Lock}
            value={password}
            onChange={(e) => handlePasswordChange(e)}
            hasError={false}
          />
        </div>}

        {/* Submit Button */}
        <div className="pt-4">
          <button
            type="submit"
            className="w-full flex justify-center py-3 px-4 border border-transparent rounded-lg shadow-sm text-md font-semibold text-slate-100 
                       bg-slate-700 hover:bg-slate-600 
                       hover:drop-shadow-[0_0_5px_rgba(203,213,225,0.2)] 
                       active:bg-gradient-to-br active:from-slate-700 active:to-slate-800 
                       focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-slate-500 focus:ring-offset-slate-900 
                       transition duration-300 uppercase tracking-wide"
          >
            {resetTrigger && resetTrigger.reset ? "RESET PASSWORD": "SEND RESET LINK"}
          </button>
        </div>
      </form>
    </div>
)};